import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box, Grid } from '@mui/material';
import { Typography, colors } from '@leapeasy/ui-kit';
import { formatDispositioned } from '../shared/delegationPropertyTable';
import { useDemoMask } from 'hooks/useDemoMask';
import { formatBooleanYesNo } from 'utils/formatBooleanYesNo';

const DetailField = ({ label, value }) => (
  <Box sx={{ mb: 2 }}>
    <Typography
      variant="body2"
      style={{ fontWeight: 600, color: colors.purple[700], marginBottom: 4 }}
    >
      {label}
    </Typography>
    <Typography variant="body2" style={{ color: colors.neutral[900] }}>
      {value ?? '-'}
    </Typography>
  </Box>
);

const Section = ({ title, fields }) => (
  <Box
    sx={{
      mb: 3,
      p: 2,
      borderRadius: 2,
      border: '1px solid #EAEAEA',
      backgroundColor: '#FAFAFA',
    }}
  >
    <Typography
      variant="body1"
      style={{ fontWeight: 600, color: colors.purple[900], marginBottom: 12 }}
    >
      {title}
    </Typography>
    <Grid container spacing={2}>
      {fields.map(({ label, value }) => (
        <Grid item xs={12} sm={6} md={4} key={label}>
          <DetailField label={label} value={value} />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export const RequestBuildingDetailDialog = ({ building, onClose }) => {
  const { mask } = useDemoMask();
  if (!building) return null;

  return (
    <Dialog open={Boolean(building)} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
        }}
      >
        <Typography variant="h3" style={{ color: colors.purple[900], fontWeight: 500 }}>
          {mask('building-name', building.name) || 'Property details'}
        </Typography>
        <IconButton aria-label="close" onClick={onClose}>
          ×
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Section
          title="General information"
          fields={[
            { label: 'Property name', value: mask('building-name', building.name) },
            { label: 'Property type', value: building.building_type },
            { label: 'Phone', value: mask('phone', building.phone) },
            { label: 'Billing street', value: mask('address-street', building.billingStreet) },
            { label: 'Primary contact', value: mask('primary-contact', building.primary_contact) },
            { label: 'Email address', value: mask('email', building.email_address) },
            { label: 'Student housing', value: formatBooleanYesNo(building.student_housing) },
            { label: 'Dispositioned', value: formatDispositioned(building.dispositioned) },
            { label: 'Operator', value: mask('landlord-name', building.landlord_name) },
          ]}
        />
        <Section
          title="Occupancy"
          fields={[
            { label: 'Total units', value: building.total_of_units },
            { label: 'Leap % of inventory', value: building.leap_of_total_inventory },
          ]}
        />
        <Section
          title="Application summary"
          fields={[
            { label: 'Last application date', value: building.last_application_date },
            { label: 'Total applications', value: building.total_of_applications },
            { label: 'Approval rate', value: building.building_approval_rate },
            { label: 'Issued policies', value: building.total_of_issued_policies },
          ]}
        />
      </DialogContent>
    </Dialog>
  );
};
